<div class="flex flex-col gap-6">
  <h1 class="textTabsColor text-2xl font-bold" i18n="@@addStockTitle">Add Stock</h1>
  <app-add-all-stock-form />
</div>
